module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-02.290f46b.jpg";